import React, {Component} from 'react';
import {withRouter, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as paymentActions from '../../actions/paymentActions';
import {clearBasket, closeBasket} from '../../actions/basketActions';
import Spinner from '../../components/Spinner/Spinner';
import ErrorTimeoutView from '../../components/App/ErrorTimeoutView';
import * as _ from 'lodash';
import moment from 'moment/moment';
import {confirmAlert} from 'react-confirm-alert';
import {actionWrapper} from '../../helpers';
import {translate} from "react-i18next";
import {DEFAULT_LIFETIME_ORDER_COOKING_TIME, DEFAULT_LANGUAGE} from '../../constants';
import * as orderActions from '../../actions/orderActions';
import * as restaurantActions from '../../actions/restaurantActions';
import {List} from "immutable";

class AssertPayment extends Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.retryPayment = this.retryPayment.bind(this);
    this.returnPayment = this.returnPayment.bind(this);
    this.checkOrderTime = this.checkOrderTime.bind(this);
    this.createOrder = this.createOrder.bind(this);
    this.state = {
      confirm: {},
      fail: false,
      errors: {},
      inProgress: false
    };
  }

  close() {
    this.props.history.push('/products/pizza');
  }

  componentDidMount() {
    const params = this.props.match.params;
    const {language} = this.props;
    this.props.assertPayment(language, params.type, params.transactionId, this.props.selectedID).then(() => {
      this.showConfirm('assert', true);
      this.props.clearBasket();
      this.props.closeBasket();
    }).catch(() => {
      this.showError();
    });
  }

  showConfirm(action, success = false) {
    this.setState({
      confirm: {
        success: success,
        action: action,
        onConfirm: this.close,
      },
    });
  }

  showError() {
    this.setState({fail: true});
  }

  returnPayment() {
    const {language, restaurant} = this.props;
    this.props.history.push(`/${language}/${restaurant.name_for_url}/recap`);
  }

  retryPayment() {
    const {restaurant} = this.props;

    const data = {
      restaurantId: restaurant.id,
      payment: 'card',
      takeAway: 'take_away',
    };
    actionWrapper(this, data, this.confirmOrderHandler.bind(this)).then((response) => {
      const responseData = response.data;
      if (responseData.payment === 'card' && responseData.transaction) {
        if (responseData.transaction.redirect_url) {
          window.location = responseData.transaction.redirect_url;
        }
      }
    });
  }

  confirmOrderHandler(data) {
    const {restaurant, t, checkRestaurantIsClosed} = this.props;
    const {createOrder} = this;
    return checkRestaurantIsClosed(restaurant.id, t).then(this.checkOrderTime).then(() => createOrder(data));
  };

  createOrder(data) {
    const {createOrder, basket, selectedTime} = this.props;
    return createOrder({
      ...data,
      detail: basket,
      selectedTime: selectedTime.label,
    });
  }

  checkOrderTime() {
    const {getOrderTimeCooking, restaurant, updateRestaurantOrderTime, t, selectedTime} = this.props;
    return getOrderTimeCooking(restaurant.id).then((response) => {
      const {order_period, order_period_modified} = response.data;
      if (moment(selectedTime.value, 'HHmm').diff(moment(), 'minutes') < order_period &&
          order_period_modified && moment(order_period_modified)
              .add(DEFAULT_LIFETIME_ORDER_COOKING_TIME || 2, 'hours')
              .isAfter(moment())) {
        confirmAlert({
          message: t('many_orders'),
          buttons: [
            {
              label: t('continue'),
              onClick: () => updateRestaurantOrderTime({
                ...restaurant,
                order_period,
                order_period_modified,
              }),
            },
          ],
        });
        return Promise.reject(false);
      }
      return Promise.resolve(true);
    });
  }


  render() {
    const {confirm, fail, inProgress} = this.state;
    const {restaurant, profile, payment, t, selectedTime, language} = this.props;
    const pickUpTimeLabel = localStorage.getItem("pickUpTimeLabel");
    if (!List.isList(payment.get('list'))) return <Spinner text={t('loading_data')}/>;
    if (_.isEmpty(restaurant)) return <Spinner text={t('loading_data')}/>;
    if (fail && _.isEmpty(restaurant)) return <Spinner text={t('loading_data')}/>;
    if (_.isEmpty(selectedTime)) return <Spinner text={t('loading_data')}/>;
    const lng = language || DEFAULT_LANGUAGE;
    return (
        <div>
          {!fail && !_.isEmpty(confirm) &&
            <Redirect
              to={{
                pathname: `/${lng}/order/confirm`,
                state: {
                  'orderId': payment.get('list').toArray()[0]['Transaction']['OrderId'],
                  'orderTime': pickUpTimeLabel,
                  'userEmail': profile.get('email'),
                  'restaurantName': restaurant.name,
                  'amount': payment.get('list').toArray()[0]['Transaction']['Amount']['Value'] / 100,
                  'result': payment.get('list').toArray()[0]['result']
                }
              }}
            />
          }
          {fail && <ErrorTimeoutView
              onReturn={this.returnPayment}
              onRetry={this.retryPayment}
              errorPayment={true}
              inProgress={inProgress}
          />}
        </div>
    );
  }
}

AssertPayment.propTypes = {};

function mapStateToProps(state) {
  return {
    selectedID: state.restaurants.selectedId,
    restaurant: state.restaurants.item,
    basket: state.basket,
    profile: state.user.get('profile'),
    selectedTime: state.pickUpTime.selectedOption,
    payment: state.payment,
    language: state.language.defaultLanguage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assertPayment: bindActionCreators(paymentActions.assertPayment, dispatch),
    clearBasket: bindActionCreators(clearBasket, dispatch),
    closeBasket: bindActionCreators(closeBasket, dispatch),
    createOrder: bindActionCreators(orderActions.createOrder, dispatch),
    getOrderTimeCooking: bindActionCreators(restaurantActions.getOrderTimeCooking, dispatch),
    checkRestaurantIsClosed: bindActionCreators(restaurantActions.checkRestaurantIsClosedNow,
        dispatch),
    updateRestaurantOrderTime: bindActionCreators(restaurantActions.updateRestaurantOrderTime,
        dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('translations')(AssertPayment)));


// WEBPACK FOOTER //
// ./src/containers/Payment/AssertPayment.js